import { render, staticRenderFns } from "./PublishRegistrationStatusSelection.vue?vue&type=template&id=0e3fbe20&"
import script from "./PublishRegistrationStatusSelection.vue?vue&type=script&lang=ts&"
export * from "./PublishRegistrationStatusSelection.vue?vue&type=script&lang=ts&"
import style0 from "./PublishRegistrationStatusSelection.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports